package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.create_product_ingredients


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Ingredient(
    @SerialName("code")
    val code: String?,
    @SerialName("group")
    val group: String?,
    @SerialName("id")
    val id: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("__typename")
    val typename: String?,
    @SerialName("units")
    val units: String?
)